import { Component } from '@angular/core';
import { TreeViewProviderDirective } from '@app/providers';
import { Item, ItemActionResult } from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';

import { map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-action-send-form-data-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ActionSendFormDataActionComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  override doExecuteWithItem(item: Item): Observable<any> {
    this.itemProvider.refresh();
    return this.itemViewProvider.executeAction(this.action.name, item).pipe(
      map((result) => new ItemActionResult(result, item)),
      tap((r: ItemActionResult) => this.updateItem(r))
    );
  }

  override updateItem(itemActionResult: ItemActionResult): void {
    super.updateItem(itemActionResult);
    if (
      !!this.itemViewProvider.listViewProvider &&
      !(
        this.itemViewProvider.listViewProvider instanceof
        TreeViewProviderDirective
      )
    ) {
      this.itemViewProvider.listViewProvider.refresh();
    }
  }
}
